import React from "react";
import { Link } from "react-router-dom";

export const MaterialIcon = ({ icon, className = '' }) => {
	return (
		<span className={`material-symbols-outlined ${className}`}>{icon}</span>
	);
};

export const ContentContainer = ({
	colour = "white",
	children,
	classes = "",
}) => {
	return (
		<div
			className={`content-container content-container--${colour} ${classes}`}>
			{children}
		</div>
	);
};

export const TitleHeader = ({
	icon = "description",
	title,
	rightContent = null,
}) => {
	return (
		<div className="title-header">
			<div className="title-header__left">
				{icon && (
					<MaterialIcon icon={icon} className="title-header__icon" />
				)}
				<h1 className="title-header__title">{title}</h1>
			</div>
			{rightContent && (
				<div className="title-header__right-content">{rightContent}</div>
			)}
		</div>
	);
};

export const Button = ({
	icon,
	type = "primary",
	text,
	onClick,
	className = '',
	size,
	disabled = false,
	buttonType = "button",
}) => {
	return (
		<button
			className={`btn btn-${type} ${className} ${size ? `btn-${size}` : ``}`}
			onClick={onClick}
			disabled={disabled}
			type={buttonType}
		>
			{icon && <MaterialIcon icon={icon} className="button__icon" />}
			{text && <span className="button__text">{text}</span>}
		</button>
	);
};

export const LinkButton = ({
	icon = null,
	type = "primary",
	text,
	to,
	className,
	size,
}) => {
	return (
		<Link
			className={`btn btn-${type} ${className} ${size ? `btn-${size}` : ``}`}
			to={to}>
			{icon && <MaterialIcon icon={icon} className="button__icon" />}
			{text && <span className="button__text">{text}</span>}
		</Link>
	);
};

export const Seperator = () => {
	return <div className="content-separator"></div>;
};

export const NarrowContentWrapper = ({ children }) => {
	return (
		<div className="row">
			<div className="col-sm-8">{children}</div>
		</div>
	);
};

export const AlertMessage = ({ type, message, classes = '' }) => {
	return <div className={`alert-banner alert-banner__${type} ${classes}`}>{message}</div>;
};

export const TableLoading = ({rows = 3}) => {
	return (
		<div className="table-loading">
			{[...Array(rows)].map((e, i) => (
				<div className="table-loading__row loading-gradient" key={i} />
			))}
		</div>
	);
}

export const FieldsLoading = ({rows = 3}) => {
	return (
		<div className="field-loading">
			{[...Array(rows)].map((e, i) => (
				<div className="form-row" key={i}>
					<div className="col-sm-6">
						<div className="field-loading__label loading-gradient"></div>
						<div className="field-loading__field loading-gradient"></div>
					</div>
					<div className="col-sm-6">
						<div className="field-loading__label loading-gradient"></div>
						<div className="field-loading__field loading-gradient"></div>
					</div>
				</div>
			))}
		</div>
	);
}

export const LoadingSpinner = ({text = null}) => {
	return (
		<div className="loading-spinner">
			<div className="loading-spinner__spinner">
				<MaterialIcon icon="progress_activity" />
			</div>
			{(text != null) && <div className="loading-spinner__text">{text}</div>}
		</div>
	);
}